<template>
  <div class="flex-group" style="border-bottom: 1px solid grey;padding: 10px;">
    <div class="item" style="flex: 1; margin-right: 20px;text-align: left;">
      <p class="txt-bold">
        金额：{{ SafeItem.amount
        }}<span style="float: right; color: #999">{{
          SafeItem.created_at
        }}</span>
      </p>
      <p class="payType">{{ SafeItem.pay_way }}</p>
      <p v-if="SafeType == 2 || SafeType == 1">订单号：{{ SafeItem.out_trade_no }}</p>
    </div>
    <div class="item">
      <p class="status" v-if="SafeType == 1">
        {{ stateType12[SafeItem.state] }}
      </p>
      <p class="status" v-if="SafeType == 2">
        {{ stateType22[SafeItem.state] }}
      </p>
      <p class="status" v-if="SafeType == 3 || SafeType == 4">
        {{ stateType34[SafeItem.state] }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransreCordItemView',
  props: ['item','type'],
  computed: {
    SafeType(){
        return this.type || 0
    },
    SafeItem () {
      return this.item || {}
    }
  },
  data(){
    return {
        stateType12: ['待支付', '成功', '失败', '超时'],
      stateType22: ['','待审核','通过','拒绝'],
      statuType: ['无效注单', '已结算', '未结算'],
      stateType34: ['失败', '成功', '待结算', '未定义'],
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-group {
  height: 68px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 1px solid rgba(58, 58, 58, 0.5);
  .item {
    display: inline-block;
    position: relative;
    p {
      font-size: 14px;
      color: #999;
      line-height: 22px;
    }
    p.txt-bold {
      color: #fff;
    }
    .item p.payType {
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>
